import { Divider, Typography } from "@mui/material";
import { t } from "i18next";
import { MuiPopup, MuiStack } from "../../components";
var SECTION_CONFIG = [{
        FutureAdviceTypeName: "IRG",
        label: "Important Repair Guidance (IRG)"
    }, {
        FutureAdviceTypeName: "Caution",
        label: "Caution"
    }];
export default function FutureAdvicePopup(_ref) {
    var onClose = _ref.onClose, futureAdviceList = _ref.futureAdviceList;
    var groupedItems = {
        IRG: futureAdviceList === null || futureAdviceList === void 0 ? void 0 : futureAdviceList.filter(function (item) { return item.FutureAdviceTypeName === "Important Repair Guidance (IRG)"; }),
        Caution: futureAdviceList === null || futureAdviceList === void 0 ? void 0 : futureAdviceList.filter(function (item) { return item.FutureAdviceTypeName === "Caution"; })
    };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        variant: "h1",
        openPopup: true,
        closeIcon: true,
        backdropEnable: true,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        padding: 0,
        margin: 0,
        width: "100%"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        alignItems: "center",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "18px",
        fontWeight: 600
    }, t("Future advice available!")), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: "center",
        justifyContent: "center",
        sx: {
            width: 30,
            height: 30,
            borderRadius: "50%",
            border: "1px solid",
            borderColor: "primary.main",
            color: "primary.main",
            fontWeight: 600,
            fontSize: "14px"
        }
    }, futureAdviceList === null || futureAdviceList === void 0 ? void 0 : futureAdviceList.length)), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "14px",
        fontWeight: 400,
        color: "secondary.600",
        mt: 1
    }, t("Please check present"), " ", /*#__PURE__*/ React.createElement(Typography, {
        component: "span",
        fontSize: "14px",
        fontWeight: 700
    }, t("Future Advice")), " ", t("that has been carried forward from the previous transaction.")), /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            my: 3
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        spacing: 3,
        sx: {
            maxHeight: "420px",
            overflowY: "auto",
            overflowX: "hidden",
            pb: "24px",
            pr: "8px",
            "&::-webkit-scrollbar": {
                width: "6px"
            },
            "&::-webkit-scrollbar-thumb": {
                background: "#B6BDC6",
                borderRadius: "8px"
            }
        }
    }, SECTION_CONFIG.map(function (_ref2) {
        var FutureAdviceTypeName = _ref2.FutureAdviceTypeName, label = _ref2.label;
        var items = groupedItems[FutureAdviceTypeName];
        if (!(items !== null && items !== void 0 && items.length))
            return null;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            key: FutureAdviceTypeName,
            direction: "column",
            spacing: 1.5
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "16px",
            fontWeight: 700
        }, t(label)), items.map(function (item, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
            key: index,
            direction: "row",
            alignItems: "center",
            sx: {
                width: "100%",
                borderRadius: "8px",
                border: "1px solid",
                borderColor: "secondary.200",
                backgroundColor: "secondary.100",
                padding: "16px 20px"
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
        }, "".concat(index + 1, ". ").concat(item.SuggestionContent))); }));
    }))));
}
